import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from '../store/useStore';
import Logo from '../components/Logo';
import VisionShowcase from '../components/VisionShowcase';

export default function VisionPage() {
  const navigate = useNavigate();
  const theme = useStore((s) => s.theme);
  const accessToken = useStore((s) => s.accessToken);

  useEffect(() => {
    document.title = 'Backora — Vision';
  }, []);

  const goToApp = () => navigate(accessToken ? '/home' : '/');

  return (
    <div className={`vision-single ${theme}`}>
      <nav className="vision-nav-thin">
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer', display: 'flex' }}>
          <Logo size={24} />
        </div>
        <button className="vision-cta-small" onClick={goToApp}>
          {accessToken ? 'Dashboard' : 'Try Backora'} &rarr;
        </button>
      </nav>

      <div className="vision-stage">
        <div className="vision-heading">
          <h1 className="vision-big-title">Backora</h1>
          <p className="vision-big-sub">
            Draw your database. Ship your backend.
          </p>
        </div>

        <VisionShowcase />

        <div className="vision-cta-row">
          <button className="vision-cta-big" onClick={goToApp}>
            {accessToken ? 'Go to dashboard' : 'Try Backora'} &rarr;
          </button>
          <span className="vision-cta-hint">
            Entity &middot; DTO &middot; Service &middot; Controller &middot; Security &middot; Swagger &middot; in one click
          </span>
        </div>
      </div>
    </div>
  );
}
